import FilterTranslatorConverter from '../FilterTranslatorConverter';
const filterTranslator = {
  original: () => {
    return {
      type: 'exists',
      field: 'data/replacementTimestamp',
      not: true
    };
  },
  replacement: () => {
    return {
      type: 'exists',
      field: 'data/replacementTimestamp'
    };
  }
};
export default FilterTranslatorConverter.create('sale.locatorReplacementType', filterTranslator);